import MinerServerList from './MinerServerList';

export default MinerServerList;
